import React from "react";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";

export default function PrivacyPage() {
  const { t } = useLang();
  useDocumentTitle(t("Política de Privacidade · ReiMultiBlog", "Privacy Policy · ReiMultiBlog"));
  return (
    <InfoLayout title={t("Política de Privacidade", "Privacy Policy")} crumb={t("Privacidade", "Privacy")}>
      <p>{t(
        "O ReiMultiBlog respeita a tua privacidade. Este site recolhe apenas os dados estritamente necessários ao seu funcionamento.",
        "ReiMultiBlog respects your privacy. This site collects only the data strictly necessary for its operation.")}</p>
      <h2>{t("Dados recolhidos", "Data we collect")}</h2>
      <p>{t(
        "Não recolhemos dados pessoais dos leitores sem consentimento. Podem ser usados cookies técnicos e estatísticas agregadas de visitas para melhorar o conteúdo.",
        "We do not collect readers' personal data without consent. Technical cookies and aggregated visit statistics may be used to improve content.")}</p>
      <h2>{t("Links externos", "External links")}</h2>
      <p>{t(
        "Alguns artigos podem conter links para sites de terceiros, incluindo links de afiliado. Não somos responsáveis pelas práticas de privacidade desses sites.",
        "Some articles may contain links to third-party sites, including affiliate links. We are not responsible for the privacy practices of those sites.")}</p>
      <h2>{t("Contacto", "Contact")}</h2>
      <p>{t("Para questões de privacidade: contacto@grouprei.com", "For privacy matters: contacto@grouprei.com")}</p>
    </InfoLayout>
  );
}
